var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-12"},[_c('div',{staticClass:"text-4xl text-center"},[_vm._v(" Loading... ")])])}]

export { render, staticRenderFns }